import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { FeaturedBrand } from "../models/featuredbrand-interface";
import { ApiResponse, FetchResponse } from "src/app/shared/models/api-response.interface";

@Injectable({
  providedIn: "root",
})
export class FeaturedbrandApiService {
  apiUrl!: string;
  apiV!: string;
  constructor(
    private httpClient : HttpClient
  ) {
    this.apiUrl = environment.apiURL;
    this.apiV = environment.version;
  }

  fetchFeturedBrands(){
    let params = new HttpParams();
    params = params.append('PageIndex', 0);
    params = params.append('PageSize', 10);
    return this.httpClient.get<ApiResponse<FetchResponse<FeaturedBrand[]>>>(this.apiUrl + `/api/${this.apiV}/Brand`, {params: params});
   
  }
}
